import { Link } from "@tanstack/react-router";
import { EyebrowLabel } from "@/components/ui-ext/Badge";

/**
 * Structured internal-link cluster for service and industry pages.
 * Reinforces the silo structure by linking to related services,
 * top industries, and headquarters location.
 */

type ClusterLink = {
  to: string;
  params?: Record<string, any>;
  anchor: string;
  note: string;
};

interface SiloDiscoveryProps {
  heading: string;
  intro: string;
  links: ClusterLink[];
  eyebrow?: string;
}

export function SiloDiscovery({ heading, intro, links, eyebrow = "Silo discovery" }: SiloDiscoveryProps) {
  return (
    <section className="scroll-mt-24 mt-16 border-t border-border pt-12">
      <EyebrowLabel>{eyebrow}</EyebrowLabel>
      <h2 className="mt-4 font-display text-3xl md:text-4xl">{heading}</h2>
      <p className="mt-3 max-w-2xl text-sm md:text-base text-muted-foreground leading-relaxed">
        {intro}
      </p>
      <ul className="mt-8 grid gap-3 sm:grid-cols-2">
        {links.map((l) => (
          <li key={l.to + l.anchor} className="surface-card p-5 group hover:border-primary/30 transition-colors">
            <Link 
              to={l.to as any} 
              params={l.params as any}
              className="font-medium text-primary hover:underline underline-offset-4"
            >
              {l.anchor}
            </Link>
            <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
              {l.note}
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
}
